import {get} from 'aws-amplify/api';
import {Command, type GetMethod} from '../../Command';

import type {GetNotificationResponse} from '../../../dto/notification/GetNotificationResponse';

export class GetNotificationCommand extends Command<GetMethod, GetNotificationResponse> {
  constructor() {
    super(get, {
      path: `/notifications`,
    });
  }

  async deserialize(output: ReturnType<typeof get>): Promise<GetNotificationResponse> {
    const {body} = await output.response;
    return await (body.json() as unknown as Promise<GetNotificationResponse>);
  }
}
